import { render, staticRenderFns } from "./TablePaginatedContacts.vue?vue&type=template&id=8ac904ea"
import script from "./TablePaginatedContacts.vue?vue&type=script&lang=js"
export * from "./TablePaginatedContacts.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedContacts.vue?vue&type=style&index=0&id=8ac904ea&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports